'use client';

import React, { useEffect, useCallback } from 'react';

export const SkipLink = (props: { focusTargetSelector?: string }) => {
  const { focusTargetSelector } = props;
  const handleSkip = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();

      const main = document.querySelector<HTMLElement>('main');
      const header = document.querySelector<HTMLElement>('header');

      if (!main || !header) return;

      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
      ];

      const firstFocusable = focusTargetSelector
        ? main.querySelector<HTMLElement>(focusTargetSelector)
        : main.querySelector<HTMLElement>(focusableSelectors.join(','));

      const target = firstFocusable || main;

      const hasTabindex = target.hasAttribute('tabindex');
      if (!hasTabindex) target.setAttribute('tabindex', '-1');

      target.focus();
      target.addEventListener(
        'blur',
        () => {
          if (!hasTabindex) target.removeAttribute('tabindex');
        },
        { once: true },
      );

      const headerHeight = header.offsetHeight;
      if (window.scrollY < headerHeight) {
        window.scrollTo({ top: headerHeight + 1, behavior: 'smooth' });
      }
    },
    [focusTargetSelector],
  );

  useEffect(() => {
    const header = document.querySelector<HTMLElement>('header');
    if (!header) return;

    const handleFocusIn = (e: FocusEvent) => {
      if (header.contains(e.target as Node)) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return (
    <div className="relative xl:max-w-screen-xl lg:mx-auto">
      <button
        onClick={handleSkip}
        aria-label="Salta al contenuto principale"
        className="absolute -top-20 left-4 z-50 rounded-md px-4 py-1 text-sm font-medium shadow-md bg-white focus:transition-all focus:top-24 focus:outline-none focus:ring-2 focus:ring-primary xl:left-0"
      >
        Skip to main content
      </button>
    </div>
  );
};
